export const UserActionKey = {
  VIEW_DETAILS: 'view_details',
  EDIT: 'edit',
  REINVITE: 'reinvite',
  SEND_INVITATION: 'send_invitation',
  CANCEL_INVITATION: 'cancel_invitation',
  DEACTIVATE: 'deactivate',
  RESET_PASSWORD: 'reset_pass',
  ACTIVATE: 'activate',
  DELETE: 'delete',
  REMOVE_EMPLOYEE_ROLE: 'remove_employee_role',
  GRANT_EMPLOYEE_ROLE: 'grant_employee_role',
} as const;

export const UserFilterTabKey = {
  ACTIVE: 'active',
  ACTIVATED_BEFORE: 'activated_before',
  PENDING: 'pending',
  EXPIRED: 'expired',
  DRAFT: 'draft',
  CANCELLED: 'cancelled',
  INACTIVE: 'inactive',
  ALL: 'all',
} as const;
